import React from 'react';
import classNames from 'classnames';

import _ from 'lodash';

import Table from 'components/Table';
import {DetailTenantInfo} from 'components/TenantInfo';

import StatusBox from 'components/StatusBox';
import {KYC_STATUSES_COLORS} from 'ducks/bookings';

import './styles.css';

const KycRow = ({kyc, openKycModal}) => (
  <Table.Row
    className={classNames('kycRow', {highlighted: kyc.status == 'pending'})}
    onClick={() => openKycModal({kycId: kyc.id})}>
    <Table.Cell>
      <DetailTenantInfo tenant={kyc.agreementUser} />
    </Table.Cell>
    <Table.Cell>{kyc.role}</Table.Cell>
    <Table.Cell>
      <StatusBox status={kyc.status} color={KYC_STATUSES_COLORS[kyc.status]} />
    </Table.Cell>
  </Table.Row>
);

const KycTable = ({kycs, tenants, guarantor, openKycModal}) => {
  const primaryTenant = tenants.find(t => t.isPrimary === true);
  const secondaryTenant = tenants.find(t => t.isPrimary === false);
  let primaryTenantKyc, secondaryTenantKyc, guarantorKyc;

  if (!_.isEmpty(kycs)) {
    if (primaryTenant) {
      primaryTenantKyc = kycs.find(
        kyc => kyc.agreementUserId === primaryTenant.agreementUserId
      );

      if (primaryTenantKyc) {
        primaryTenantKyc = {
          ...primaryTenantKyc,
          agreementUser: primaryTenant,
          role: 'Primary'
        };
      }
    }

    if (secondaryTenant) {
      secondaryTenantKyc = kycs.find(
        kyc => kyc.agreementUserId === secondaryTenant.agreementUserId
      );

      if (secondaryTenantKyc) {
        secondaryTenantKyc = {
          ...secondaryTenantKyc,
          agreementUser: secondaryTenant,
          role: 'Secondary'
        };
      }
    }

    if (guarantor) {
      guarantorKyc = kycs.find(
        kyc => kyc.agreementUserId === guarantor.agreementUserId
      );

      if (guarantorKyc) {
        guarantorKyc = {
          ...guarantorKyc,
          agreementUser: guarantor,
          role: 'Guarantor'
        };
      }
    }
  }

  return (
    <div className="KycTable">
      <Table>
        <Table.Header>
          <Table.HeaderItem className="name" heading="Name" />
          <Table.HeaderItem className="role" heading="Role" />
          <Table.HeaderItem className="status" heading="Status" />
        </Table.Header>
        <Table.Body>
          {primaryTenantKyc && (
            <KycRow kyc={primaryTenantKyc} openKycModal={openKycModal} />
          )}
          {secondaryTenantKyc && (
            <KycRow kyc={secondaryTenantKyc} openKycModal={openKycModal} />
          )}
          {guarantorKyc && (
            <KycRow kyc={guarantorKyc} openKycModal={openKycModal} />
          )}
        </Table.Body>
      </Table>
    </div>
  );
};

export default KycTable;
